import React from 'react';
import {Navigate, Route, Routes} from 'react-router';
import {OrdersPage} from "./pages/OrdersPage";
import {LoginPage} from "./pages/LoginPage";
import {Header} from "./components/Header";
import {ClientsPage} from "./pages/ClientsPage";
import {ClientDetailsPage} from "./pages/ClientDetailsPage";
import {ProductsPage} from "./pages/ProductsPage";
import {ContentSolutionsPage} from "./pages/ContentSolutionsPage";
import {ProductCategoriesPage} from "./pages/ProductCategoriesPage";
import {OrderDetailsPage} from "./pages/OrderDetailsPage";

const useRoutes = (isAuthenticated) => {
    if(isAuthenticated){
        return (
            <div className={"admin-layout"}>
                <Header/>
                <Routes>
                    <Route path="/orders" element={<OrdersPage/>} />
                    <Route path="/orders/:id" element={<OrderDetailsPage/>} />
                    <Route path="/clients" element={<ClientsPage/>} />
                    <Route path="/clients/:id" element={<ClientDetailsPage/>} />
                    <Route path="/products" element={<ProductsPage/>} />
                    <Route path="/solutions" element={<ContentSolutionsPage/>} />
                    <Route path="/product-categories" element={<ProductCategoriesPage/>} />
                    <Route path="*" element={<Navigate to="/orders" />} />
                </Routes>
            </div>
        );
    }
    return (
        <Routes>
            <Route path="/" element={<LoginPage/>} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    )
}
export default useRoutes;
